import accounts from 'store/modules/accounts/accounts';
import common from 'store/modules/common/common';
import dirtyTracker from 'store/modules/dirtyTracker';
import projects from 'store/modules/projects/projects';
import routing from 'store/modules/routing/routing';
import sidebar from 'store/modules/sidebar/sidebar';
import user, {FETCH_USER_NOTES} from 'store/modules/user/user';
import channels, {FETCH_WA_PROVIDERS, FETCH_CHANNELS} from 'store/modules/channels/channels';
import enums, {FETCH_ENUMS} from 'store/modules/enums/enums';
import params from 'store/modules/params/params';
import placements from 'store/modules/placements';
import connections from 'store/modules/connections';
import orders_old from 'store/modules/orders_old';
import bidmanager from 'store/modules/bidmanager';
import contract from 'store/modules/contract';
import roles, {FETCH_ROLES_LIST} from 'store/modules/roles';
import releaseNotes, {FETCH_RELEASE_NOTES} from 'store/modules/releasenotes';
import quickstart from 'store/modules/quickstart';
import dashboards from 'store/modules/dashboards/dashboards';
import managers from 'store/modules/managers/managers';
import onboarding from 'store/modules/onboarding/onboarding';
import notifications from 'store/modules/notifications/notifications';
import webanalytics from 'store/modules/webanalytics';

export const modules = {
  accounts,
  common,
  dirtyTracker,
  projects,
  routing,
  sidebar,
  user,
  channels,
  enums,
  params,
  placements,
  connections,
  orders_old,
  bidmanager,
  contract,
  roles,
  releaseNotes,
  quickstart,
  dashboards,
  managers,
  onboarding,
  notifications,
  webanalytics
};

export const actions = {
  FETCH_USER_NOTES,
  FETCH_WA_PROVIDERS,
  FETCH_CHANNELS,
  FETCH_ENUMS,
  FETCH_ROLES_LIST,
  FETCH_RELEASE_NOTES
};
